import { Node } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

export const FIELD_TOKEN_DELETE_META = 'allowFieldTokenDelete';

function collectFieldTokenUuids(doc) {
  const uuids = new Set();
  doc.descendants((node) => {
    if (node.type.name === 'fieldToken' && node.attrs.uuid) {
      uuids.add(node.attrs.uuid);
    }
  });
  return uuids;
}

export const FieldToken = Node.create({
  name: 'fieldToken',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      uuid: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-field-uuid'),
        renderHTML: (attributes) => ({
          'data-field-uuid': attributes.uuid,
        }),
      },
      key: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-field-key') || '',
        renderHTML: (attributes) => ({
          'data-field-key': attributes.key,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-field-token]',
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-field-token': 'true',
        class: 'field-token',
        contenteditable: 'false',
        title: 'Clique para localizar no painel de campos',
      },
      `{${node.attrs.key}}`,
    ];
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        filterTransaction: (transaction, state) => {
          if (!transaction.docChanged) return true;
          if (transaction.getMeta(FIELD_TOKEN_DELETE_META)) return true;

          const before = collectFieldTokenUuids(state.doc);
          const after = collectFieldTokenUuids(transaction.doc);

          for (const uuid of before) {
            if (!after.has(uuid)) return false;
          }

          return true;
        },
      }),
    ];
  },
});

export default FieldToken;
